export default defineNuxtPlugin(() => {
  const { applyAccessibilitySettings } = useAccessibility()
  
  applyAccessibilitySettings()
})